var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "wish-wrapper",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _c(
        "span",
        { staticClass: "badge-right", class: { used: _vm.wishListCount > 0 } },
        [_vm._v(_vm._s(_vm.wishListCount))]
      ),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-heart", attrs: { "aria-hidden": "true" } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }